/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { ref } from 'vue';
import { businessCardApi, marketingDataApi } from '@shared/apis';
import { useUserStore } from '@shared/store';
import { useRoute } from 'vue-router';

export const useSPDBLocalizationCertificate = () => {
  const { getLocalizationCertificate } = businessCardApi;
  const { viewStaffInfo } = useUserStore();
  const route = useRoute();

  const hasLocalizationCertificate = ref(false);

  const updateLocalizationCertificate = async () => {
    try {
      const { retdata: isPuFa = false } = await marketingDataApi.getIsPfBank({});
      if (isPuFa) {
        const { retdata = false } = await getLocalizationCertificate({
          staffId: viewStaffInfo.staffId,
        });
        hasLocalizationCertificate.value = retdata;
      }
    } catch (err) {
      console.error(err);
    }
  };

  if (route.path === '/managerStation') {
    updateLocalizationCertificate();
  }

  return {
    hasLocalizationCertificate,
  };
};
